// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1YdeO","inner":"Form_inner__3cc72","range":"Form_range__3V_Fr","name":"Form_name__14mN0","actions":"Form_actions__1zUJo"};